<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { useModal } from "#/composables/useModal";
import type { IProduct } from "#/types/iCardProduct";

const emit = defineEmits<(e: "confirm") => void>();
const { visible, close } = useModal<IProduct>("cart-extend-confirm");
const { t } = useTranslation();

const onConfirm = () => {
	emit("confirm");
	close();
};
</script>

<template>
	<Transition name="fade">
		<div v-if="visible" class="cart_extend_modal_overlay" @click.self="close">
			<div class="cart_extend_modal_content">
				<div class="cart_extend_modal_title">{{ t(`cart.extend-confirm.title`) }}</div>
				<div class="cart_extend_modal_body">{{ t(`cart.extend-confirm.body`) }}</div>
				<div class="cart_extend_modal_footer">
					<button @click="close">{{ t(`cart.extend-confirm.button.cancel`) }}</button>
					<button class="primary" @click="onConfirm">{{ t(`cart.extend-confirm.button.continue`) }}</button>
				</div>
			</div>
		</div>
	</Transition>
</template>

<style lang="scss" scoped>
  @use './cartExtendConfirm.scss';
</style>
